/**
 * Per-field required/validation error lookup shared by the dashboard cards.
 *
 * Prefers the full map (every invalid field at once) and falls back to the single legacy
 * validationError, so nothing regresses if the map is ever absent.
 */
export function makeFieldError(fieldErrors, validationError) {
  return (field) =>
    fieldErrors?.[field] ?? (validationError?.field === field ? validationError.error : undefined);
}
